import { createAction } from '../../utils/redux'
import { ActionsUnion } from '../../utils/types'
import { Profile } from './types'

// actions
export const FETCH_PROFILES = 'profile/FETCH_PROFILES'
export const FETCH_PROFILES_SUCCESS = 'profile/FETCH_PROFILES_SUCCESS'

export const ProfileActions = {
  fetchAllProfiles: (limit: number, offset: number, sid: string) =>
    createAction(FETCH_PROFILES, { limit, offset, sid }),
  fetchProfilesSuccess: (profile: Profile[]) => createAction(FETCH_PROFILES_SUCCESS, profile)
}

export type ProfileActions = ActionsUnion<typeof ProfileActions>
